import React, {createContext, useContext, useEffect, useState} from "react";
import {useUser} from "./UserContext";
import {UserAuthService} from "../services/user-auth-api.service";

const JournalContext = createContext();

export const useJournal = () => useContext(JournalContext);

export const JournalProvider = ({ children }) => {
  const { user, token } = useUser();
  const [validateJournalPass, setValidateJournalPass] = useState(true);
  const [firstTimePassword, setFirstTimePassword] = useState(false);
  const [firstTimeForumPassword, setFirstTimeForumPassword] = useState(false);
  const [profileData, setProfileData] = useState([]);
  const [updateJournalProfile, setUpdateJournalProfile] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [verifyJournalOtp, setVerifyJournalOtp] = useState(false);
  const [journalPasswordSetted, setJournalPasswordSetted] = useState(true);
  const pass = true;

  async function getProfileData() {
    const response = await UserAuthService.getProfileData();

    if (response?.data?.data?.status) {
      const userData = response.data.data.data.user;
      setProfileData(userData);
      setFirstTimePassword(!userData.journalPassword); // Sets to true if journalPassword is empty or undefined
      setUserEmail(userData.email); // Sets to true if journalPassword is empty or undefined
    }
  }

  useEffect(() => {
    if (token) {
      getProfileData();
    }
  }, []);

  // This effect is useful if the user object updates and should affect firstTimePassword
  // useEffect(() => {
  //   if (pass) {
  //     setFirstTimePassword(false);
  //   } else {
  //     setFirstTimePassword(true);
  //   }
  // }, [pass]);

  // Log to debug
  // useEffect(() => {}, [firstTimePassword]);

  const value = {
    validateJournalPass,
    setValidateJournalPass,
    firstTimePassword,
    profileData,
    updateJournalProfile,
    setUpdateJournalProfile,
    setFirstTimePassword,
    userEmail,
    verifyJournalOtp,
    setVerifyJournalOtp,
    setJournalPasswordSetted,
    journalPasswordSetted,
    setFirstTimeForumPassword,
    firstTimeForumPassword,
  };

  return (
    <JournalContext.Provider value={value}>{children}</JournalContext.Provider>
  );
};
